<app-header-page>
    <h1>{{ 'HEADERS.CUSTOM_PROPERTIES' | translate }}</h1>
</app-header-page>

<ng-template #loadingg>
    <app-component-loading></app-component-loading>
</ng-template>

<div class="super__tabs">
    <div (click)="getProperties(tab !== 'board', 'board')" [class.active]="tab === 'board'"
         class="super__tabs tab"
         data-action="board">
        <span>{{ 'PROPERTIES.TYPES.BP' | translate }}</span>
    </div>
    <div (click)="getProperties(tab !== 'doc', 'doc')" [class.active]="tab === 'doc'"
         class="super__tabs tab"
         data-action="doc">
        <span>{{ 'PROPERTIES.TYPES.DOCS' | translate }}</span>
    </div>
    <div (click)="getProperties(tab !== 'contract', 'contract')" [class.active]="tab === 'contract'"
         class="super__tabs tab"
         data-action="contract">
        <span>{{ 'PROPERTIES.TYPES.CONTRACTS' | translate }}</span>
    </div>
</div>

<div>
    <button (click)="modalService.openTemplateModal(createPropertyModal)"
            class="btn btn-success"
            data-action="openCreatePropertyModal"
            style="margin-bottom: 15px"
    >
        <span>{{ 'PROPERTIES.CREATE_FIELD' | translate }}</span>
    </button>
</div>

<ng-template #createPropertyModal let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.CREATE_PROPERTY' | translate }}</h1>
        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #propertyName class="form-control" id="propertyName">

        <h2 class="mt-2">{{ 'MODALS.FIELDS.PROPERTY_TYPE' | translate }}</h2>
        <select #propertyType (change)="isMultiform = false" class="form-select">
            <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.PROPERTY.TYPE' | translate }}</option>
            <option value="property_file">{{ 'MODALS.FIELDS.SELECT.PROPERTY.FILE' | translate }}</option>
            <option value="property_member">{{ 'MODALS.FIELDS.SELECT.PROPERTY.MEMBER' | translate }}</option>
            <option value="property_text">{{ 'MODALS.FIELDS.SELECT.PROPERTY.TEXT' | translate }}</option>
            <option value="property_boolean">{{ 'MODALS.FIELDS.SELECT.PROPERTY.BOOL' | translate }}</option>
            <option value="property_catalog">{{ 'MODALS.FIELDS.SELECT.PROPERTY.CATALOG' | translate }}</option>
            <option value="property_todo">{{ 'MODALS.FIELDS.SELECT.PROPERTY.TODO' | translate }}</option>
        </select>

        <h2 *ngIf="['property_member', 'property_catalog', 'property_todo'].includes(propertyType.value)" class="mt-2">
            {{ 'MODALS.FIELDS.INTENDED' | translate }}:
        </h2>
        <select #propertyTargetValue (change)="propertyTarget = propertyTargetValue.value"
                *ngIf="propertyType.value === 'property_member'"
                class="form-select"
        >
            <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.INTENDED.INTENDED' | translate }}</option>
            <option value="all">{{ 'MODALS.FIELDS.SELECT.INTENDED.ALL' | translate }}</option>
            <option value="outer">{{ 'MODALS.FIELDS.SELECT.INTENDED.OUTER' | translate }}</option>
            <option value="inner">{{ 'MODALS.FIELDS.SELECT.INTENDED.INNER' | translate }}</option>
        </select>
        <select #propertyTargetCatalog (change)="propertyTarget = propertyTargetCatalog.value"
                *ngIf="propertyType.value === 'property_catalog' || propertyType.value === 'property_todo'"
                class="form-select"
        >
            <option hidden selected value="">{{ 'MODALS.FIELDS.SELECT.INTENDED.INTENDED' | translate }}</option>
            <option *ngFor="let catalog of allCatalogs" [value]="catalog.id">{{ catalog.title }}</option>
        </select>

        <div *ngIf="['property_member', 'property_catalog', 'property_file'].includes(propertyType.value)" class="mt-3">
            <input #isMultiformCheckbox
                   (change)="isMultiform = isMultiformCheckbox.checked"
                   [checked]="isMultiform"
                   id="isMultiformCheckbox"
                   name="isMultiformCheckbox"
                   style="width: auto;"
                   type="checkbox"
            >
            <label [innerHTML]="'MODALS.FIELDS.MULTIFORM' | translate" class="ms-1" for="isMultiformCheckbox">
            </label>
        </div>

        <button (click)="createProperty(propertyName.value, propertyType.value, modal)"
                class="btn btn-success"
                data-action="createProperty"
                style="margin-top: 15px"
        >
            <span>{{ 'MODALS.BUTTONS.PROPERTY' | translate }}</span>
        </button>
    </div>
</ng-template>

<div *ngIf="!loading; else loadingg" class="tab__content">
    <ng-container *ngTemplateOutlet="props"></ng-container>
</div>

<ng-template #props>
    <i *ngIf="tab === 'contract'">{{ 'PROPERTIES.CONTRACTS' | translate }}</i>
    <div *ngIf="propertyTextTemplate" class="row p-3">
        <div *ngFor="let key of keys" class="col-4 list-group" style="margin-top:10px">
            <h2><i [class]="propertyTextTemplate[key].icon"></i> {{ propertyTextTemplate[key].head }}</h2>

            <div *ngIf="!properties[key].length"
                 class="list-group-item list-group-item-action"
            >
                {{ propertyTextTemplate[key].empty }}
            </div>

            <div *ngFor="let prop of properties[key]; let i = index"
                 [attr.data-index-property]="i"
                 class="list-group-item list-group-item-action"
                 style="display: flex; justify-content: space-between"
            >
                <div [class.text-danger]="(prop.property_type === 'property_catalog' || prop.property_type === 'property_todo') && !prop.property_type_target"
                     [ngbTooltip]="(prop.property_type === 'property_catalog' || prop.property_type === 'property_todo') && !prop.property_type_target ? ('PROPERTIES.CATALOG_DELETED' | translate) : ''"
                >
					<span>
						{{ prop.title }}
					</span>
                    <i *ngIf="prop.is_multiform" class="bi bi-ui-checks ms-2"
                       ngbTooltip="{{ 'PROPERTIES.MULTIPLE' | translate }}"
                    ></i>

                    <span *ngIf="['property_member', 'property_catalog', 'property_todo'].includes(prop.property_type)">
						<br>{{ 'PROPERTIES.ACCESS.ACCESS' | translate }}: {{
                            prop.property_type === 'property_member' ?
                                ('PROPERTIES.ACCESS.' + prop.property_type_target | translate) :
                                prop.property_type_target ? prop.property_type_target : ('PROPERTIES.ACCESS.denied' | translate)
                        }}
					</span>
                </div>
                <span>
                    <i (click)="openProperty(prop, infoProperty, 'sm')"
                       [attr.data-action]="'infoProperty' + key"
                       class="bi bi-info-circle me-2"
                       style="cursor: pointer"
                    ></i>
					<i (click)="openProperty(prop, editProperty, 'lg')"
                       [attr.data-action]="'editProperty' + key"
                       class="bi bi-pen me-2"
                       style="cursor: pointer"
                    ></i>
					<i (click)="deleteProperty(prop)"
                       [attr.data-action]="'deleteProperty' + key"
                       class="bi bi-trash text-danger"
                       style="cursor: pointer"
                    ></i>
				</span>
            </div>
        </div>
    </div>
</ng-template>

<ng-template #infoProperty let-modal>
    <app-button-modal-close [modalSize]="'sm'" [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h2>{{ 'MODALS.HEADERS.INFO' | translate }}</h2>
        <strong>{{ 'MODALS.TEXT.TITLE' | translate }}: </strong>
        <span>{{ selectedProperty.title }}</span> <br>

        <strong>{{ 'MODALS.TEXT.MULTIPLY' | translate }}: </strong>
        <span>{{ (selectedProperty.is_multiform ? 'MODALS.TEXT.YES' : 'MODALS.TEXT.NO') | translate }}</span> <br>

        <strong>{{ 'MODALS.TEXT.TYPE.TYPE' | translate }}: </strong>
        <i [class]="propertyTextTemplate[ selectedProperty.property_type].icon"></i>
        <span>{{ propertyTextTemplate[selectedProperty.property_type].head }}</span> <br>

        <strong>{{ 'MODALS.TEXT.CREATED_AT' | translate }}: </strong>
        <span>{{ this.helper.formatDate(selectedProperty.created_at, false) }}</span><br>

        <strong>{{ 'MODALS.TEXT.UPDATED_AT' | translate }}: </strong>
        <span>{{ this.helper.formatDate(selectedProperty.updated_at, false) }}</span>

        <div *ngIf="tab === 'board'">
            <strong *ngIf="propertyInfo">{{ 'MODALS.TEXT.BOARDS' | translate }}:</strong>
            <ul *ngIf="propertyInfo.length">
                <li *ngFor="let info of propertyInfo">#{{ info.data.alias }} {{ info.data.name }}</li>
            </ul>
            <i *ngIf="!propertyInfo.length">{{ 'EMPTY_LISTS.EMPTY' | translate }}</i>
        </div>
        <div *ngIf="tab === 'doc'">
            <strong *ngIf="propertyInfo">{{ 'MODALS.TEXT.CONNECTED' | translate }}:</strong>
            <ul *ngIf="propertyInfo.length">
                <li *ngFor="let info of propertyInfo">{{ 'PROPERTIES.CONNECT.' + info.type | translate }}</li>
            </ul>
            <i *ngIf="!propertyInfo.length"><br>{{ 'EMPTY_LISTS.EMPTY' | translate }}</i>
        </div>
    </div>
</ng-template>

<ng-template #editProperty let-modal>
    <app-button-modal-close [modal]="modal"></app-button-modal-close>
    <div class="modal-body">
        <h1>{{ 'MODALS.HEADERS.EDIT_PROP' | translate }}</h1>

        <h2>{{ 'MODALS.FIELDS.TITLE' | translate }}</h2>
        <input #propName
               (change)="selectedProperty.title = propName.value"
               [value]="selectedProperty.title"
               class="form-control"
               type="text"
        >

        <h2>{{ 'MODALS.TEXT.TYPES.TYPE' | translate }}</h2>
        <span>
            {{ 'MODALS.TEXT.TYPES.' + selectedProperty.property_type | translate }}
        </span>

        <h2 *ngIf="['property_member', 'property_catalog', 'property_todo'].includes(selectedProperty.property_type)">
            {{ 'MODALS.FIELDS.INTENDED' | translate }}:
        </h2>
        <select #propertyTargetValue (change)="selectedProperty.property_type_target = propertyTargetValue.value"
                *ngIf="selectedProperty.property_type === 'property_member'" class="form-select">
            <option [selected]="selectedProperty.property_type_target === 'all'"
                    value="all"
            >
                {{ 'MODALS.FIELDS.SELECT.INTENDED.ALL' | translate }}
            </option>
            <option [selected]="selectedProperty.property_type_target === 'outer'"
                    value="outer"
            >
                {{ 'MODALS.FIELDS.SELECT.INTENDED.OUTER' | translate }}
            </option>
            <option [selected]="selectedProperty.property_type_target === 'inner'"
                    value="inner"
            >
                {{ 'MODALS.FIELDS.SELECT.INTENDED.INNER' | translate }}
            </option>
            <!--			<option  *ngIf="propertyType.value === 'property_catalog'" value="property_boolean">property_boolean</option>-->
        </select>
        <select #propertyTargetCatalog (change)="selectedProperty.property_type_target = propertyTargetCatalog.value"
                *ngIf="selectedProperty.property_type === 'property_catalog' || selectedProperty.property_type === 'property_todo'"
                class="form-select"
        >
            <option [selected]="!selectedProperty.property_type_target" hidden
                    value="">{{ 'MODALS.FIELDS.SELECT.CATALOG' | translate }}
            </option>
            <option *ngFor="let catalog of allCatalogs"
                    [selected]="selectedProperty.property_type_target === catalog.id.toString()"
                    [value]="catalog.id"
            >{{ catalog.title }}
            </option>
        </select>

        <button (click)="updateProperty(modal)"
                class="btn btn-success"
                data-action="createProperty"
                style="margin-top: 15px"
        >
            <span>{{ 'MODALS.BUTTONS.SAVE' | translate }}</span>
        </button>
    </div>
</ng-template>
